import React from 'react';
import GradingStationTableContainer from './GradingStationTableContainer';

const gradableTypeName = gradableType => {
  if (gradableType === 'content') {
    return `${t('common.filter_by')} ${t('grades.content_filter')}`;
  }
  if (gradableType === 'long-waiting') {
    return `${t('common.filter_by')} ${t('long-waitings.filter_name')}`;
  }
  if (gradableType === 'user') {
    return `${t('common.filter_by')} ${t('users.filter_name')}`;
  }
  if (gradableType === 'group') {
    return `${t('common.filter_by')} ${t('grades.group_filter')}`;
  }
  return '';
};

const GradingStationContainer = props => {
  const { canGradeGroups = false } = props;
  const params = new URLSearchParams(props.location.search);
  const page = parseInt(params.get('page'), 10) || 1;
  const gradableType = params.get('gradable_type') || 'content';
  const query = params.get('query') || '';
  const rowsPerPage = parseInt(params.get('perPage'), 10) || 10;
  const gradableTypes = canGradeGroups
    ? ['content', 'user', 'long-waiting', 'group']
    : ['content', 'user', 'long-waiting'];

  return (
    <div>
      <div className="PanelHeader">
        <h1 className="PanelHeader-title ff-ss">{t('grades.title')}</h1>
      </div>
      <GradingStationTableContainer
        page={page}
        rowsPerPage={rowsPerPage}
        history={props.history}
        gradableType={gradableType}
        query={query}
        params={params}
        gradableTypeName={gradableTypeName}
        gradableTypes={gradableTypes}
        location={props.location}
      />
    </div>
  );
};
export default GradingStationContainer;
